import React from 'react';
import { useTranslate } from 'react-admin';
import { Box, Typography } from '@mui/material';
import BaseWidget from './base';
import { DashboardWidget, TextWidgetConfig } from '../../../types/dashboard.ui';

interface TextWidgetProps {
  widget: DashboardWidget;
  editMode?: boolean;
  onEdit?: (widget: DashboardWidget) => void;
  onDelete?: (widget: DashboardWidget) => void;
}

const TextWidget: React.FC<TextWidgetProps> = ({ widget, editMode, onEdit, onDelete }) => {
  const translate = useTranslate();
  const config = (typeof widget.config === 'string' ? JSON.parse(widget.config) : widget.config) as TextWidgetConfig || {};

  return (
    <BaseWidget
      widget={widget}
      editMode={editMode}
      onEdit={() => onEdit?.(widget)}
      onDelete={() => onDelete?.(widget)}
    >
      <Box
        sx={{
          p: 2,
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: config.fontSize || 14,
            fontWeight: config.fontWeight || 'normal',
            color: config.color || 'text.primary',
            textAlign: config.alignment || 'left'
          }}
        >
          {config.content || translate('resources.dashboards.widgets.text.empty_content')}
        </Typography>
      </Box>
    </BaseWidget>
  );
};

export default TextWidget;